import { useTranslation } from 'react-i18next';

export default function BrandIntro() {
  const { t } = useTranslation();

  const descriptions = [
    t('brand.desc1'),
    t('brand.desc2'),
    t('brand.desc3'),
    t('brand.desc4'),
  ];

  const stats = [
    { value: t('brand.stat1'), label: t('brand.stat1.label') },
    { value: t('brand.stat2'), label: t('brand.stat2.label') },
    { value: t('brand.stat3'), label: t('brand.stat3.label') },
    { value: t('brand.stat4'), label: t('brand.stat4.label') },
  ];

  return (
    <section className="w-full bg-secondary-50 py-16 md:py-24">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-foreground-600 text-xs font-semibold whitespace-nowrap mb-6">
          {t('brand.tag')}
        </span>

        <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight mb-14 md:mb-20">
          {t('brand.title.line1')}
          <br />
          {t('brand.title.line2')}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-14 md:mb-20">
          {descriptions.map((desc, idx) => (
            <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {desc}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {stats.map((stat, idx) => (
            <div key={idx}>
              <div className="font-heading text-4xl md:text-6xl font-black text-primary-700 mb-2">
                {stat.value}
              </div>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}